var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullhornSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 3.87643C16.125 3.52373 15.9117 3.20384 15.5836 3.06714C15.2555 2.93044 14.8809 3.00699 14.6293 3.25579L13.4371 4.45058C12.1246 5.76294 10.3445 6.50114 8.48789 6.50114H8.25H7.375H4.75C3.78477 6.50114 3 7.28582 3 8.25095V10.8757C3 11.8408 3.78477 12.6255 4.75 12.6255V16.1251C4.75 16.609 5.14102 17 5.625 17H7.375C7.85898 17 8.25 16.609 8.25 16.1251V12.6255H8.48789C10.3445 12.6255 12.1246 13.3637 13.4371 14.676L14.6293 15.8681C14.8809 16.1196 15.2555 16.1934 15.5836 16.0567C15.9117 15.92 16.125 15.6029 16.125 15.2475V11.212C16.6336 10.9714 17 10.3234 17 9.56057C17 8.79777 16.6336 8.14979 16.125 7.90919V3.87643ZM14.375 5.97346V9.56331V13.1532C12.7672 11.6904 10.6699 10.8757 8.48789 10.8757H8.25V8.25095H8.48789C10.6699 8.25095 12.7672 7.4362 14.375 5.97346Z",
    fill: "#EC6655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhornSm);
export default __webpack_public_path__ + "static/media/bullhorn_sm.54ebad88c570d280ff0b50bed03268ab.svg";
export { ForwardRef as ReactComponent };